import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {initializeModal, readDocsList} from '../../modules/admin/docs';
import styles from './styles/modal-wrapper.module.css';

import CreateModal from './create/CreateModal';
import DeleteModal from './delete/DeleteModal';
import UpdateModal from './update/UpdateModal';
import UploadModal from './upload/UploadModal';

export default function ModalWrapper({ type, handleClose, itemToDo, itemsToDelete }) {   
    const dispatch = useDispatch();

    const {currentId, name, page} = useSelector(({ docs }) => ({
        currentId: docs.currentId,
        name: docs.name,
        page: docs.page
    }));

    const closeModal = () => {
        handleClose();
        dispatch(initializeModal());
    };

    const reReadDocsList = useCallback(() => {
        dispatch(readDocsList({ id: currentId, name, page }));
    }, []);

    return (
        <div className={styles.wrapper} onClick={() => closeModal()}>
            <div className={styles.container} onClick={(e) => e.stopPropagation()}>
                {type === 'upload' && <UploadModal handleClose={closeModal} reReadDocsList={reReadDocsList} />}
                {type === 'create' && <CreateModal handleClose={closeModal} reReadDocsList={reReadDocsList} />}
                {type === 'update' && <UpdateModal handleClose={closeModal} itemToUpdate={itemToDo} />}
                {type === 'delete' && <DeleteModal handleClose={closeModal} reReadDocsList={reReadDocsList} itemToDelete={itemToDo} itemsToDelete={itemsToDelete} />}
            </div>
        </div>
    );
}
